"use client";

import { c as _c } from "react/compiler-runtime";
import { EllipsisVerticalIcon } from "@heroicons/react/24/solid";
import { useContext } from "react";
import { DrawerContext } from "./drawer-context";
export default function DrawerToggle() {
  const $ = _c(2);
  const {
    openDrawer
  } = useContext(DrawerContext);
  let t0;
  if ($[0] !== openDrawer) {
    t0 = <button aria-label={"\xD6ppna meny"} className="sm:hidden"><EllipsisVerticalIcon onClick={openDrawer} className="h-8 w-8" /></button>;
    $[0] = openDrawer;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}